import { Component, Input } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-copy',
  templateUrl: './copy.component.html',
  styleUrls: ['./copy.component.scss'],
  standalone: false
})
export class CopyComponent {
  @Input() value: any;
  @Input() icon: string = 'content_copy';
  @Input() copiedMessage?: string;

  isHovered = false;

  constructor(
    private clipboard: Clipboard,
    private snackbar: MatSnackBar,
    private translate: TranslateService
  ) {}

  copyToClipboard() {
    const text = this.stringify(this.value);
    if (!text) return;

    this.clipboard.copy(text);
    const message = this.copiedMessage || this.translate.instant('ClipboardCopiedMessage');
    this.snackbar.open(message, undefined, { duration: 2000 });
  }

  private stringify(value: any): string {
    if (value == null) return '';
    if (typeof value === 'object') return JSON.stringify(value);
    return value.toString();
  }
}
